export default [
    {
        dm: 'yargoyt',
        text: 'Овнер',
        img: 'yargo'
    },
    {
        dm: 'shizuk3ssa',
        text: 'Кодер',
        img: 'shizu'
    },
    {
        dm: 'xeobry',
        text: 'Администратор',
        img: 'xeobry'
    },
    {
        dm: 'tryagainpups',
        text: 'Модератор листов',
        img: 'yefool'
    },
];